import { useEffect } from "react";
import { Link, Stack, Text } from "basis";
import { usePageTracking } from "react-event-tracker";
import { getAccounts } from "library/api";
import { Layout } from "../../Layout/Layout";
import { SvgInline } from "../../SvgInline/SvgInline";

const MAX_POLL_TIME = 30000;

export const Success = ({ params }) => {
  usePageTracking({
    page: {
      pageType: "confirmation-page",
      siteSection: "accounts",
      siteSubSection: params.siteSubSection,
      pageTitle: "success",
    },
    user: {
      authenticationStatus: "logged in",
    },
    productId: [params.productId],
  });
  const { account_last4: accountLast4, accountNumber } = params;
  useEffect(() => {
    const startTime = Date.now();
    let success = false;
    const pollLinks = async () => {
      try {
        const { data } = await getAccounts();

        if (accountLast4) {
          // linking Credit Card
          success =
            !!data.credit_cards &&
            data.credit_cards.some(
              (account) => accountLast4 === account.credit_card.account_last4,
            );
        } else {
          // linking PL
          const plLast4 = accountNumber.substring(accountNumber.length - 4);

          success =
            !!data.personal_loans &&
            data.personal_loans.some(
              (account) => plLast4 === account.account_last4,
            );
        }
      } catch (e) {
        // TODO: do something with error
      }
      if (!success && Date.now() - startTime < MAX_POLL_TIME) {
        setTimeout(pollLinks, 500);
      }
    };
    pollLinks();
  }, [accountLast4, accountNumber]);

  return (
    <Layout>
      <Layout.Header>
        Link {accountLast4 ? "credit card" : "personal loan"} account
      </Layout.Header>
      <Layout.Main>
        <Stack gap="6">
          <SvgInline name="icon-celebrate" size="92" />
          <Text as="h3" textStyle="heading5">
            Your account is linked!
          </Text>
          <Link appearance="primary-button" href="/" newTab={false}>
            Go to overview
          </Link>
        </Stack>
      </Layout.Main>
    </Layout>
  );
};
